/**
 * URL ảnh chương trình thưởng — ảnh serve từ API origin (api.longhousee.com),
 * KHÔNG phải domain admin. Dùng đường dẫn tương đối "/img/reward/x.jpeg" trên
 * admin.longhousee.com sẽ 404 (bug ảnh không hiện 28/07).
 */
const API_ORIGIN = (process.env.REACT_APP_API_URL || "").replace(/\/api\/v1\/?$/, "");

export function rewardImageUrl(v) {
    if (!v) return null;
    return v.startsWith("http") ? v : `${API_ORIGIN}/img/reward/${v}`;
}
